export function sanitizeWebsite(input: string | null | undefined): string | undefined {
    if (!input || typeof input !== "string") return undefined;

    const trimmed = input.trim();
    if (!trimmed) return undefined;

    const ensureProtocol = (url: string) => (/^https?:\/\//i.test(url) ? url : `https://${url}`);

    const hasValidTLD = (hostname: string) => /\.[a-z]{2,}$/.test(hostname);

    try {
        const parsed = new URL(ensureProtocol(trimmed));

        if (!hasValidTLD(parsed.hostname)) return undefined;

        let result = parsed.toString();

        if (result.endsWith("/") && !parsed.pathname.slice(1) && !parsed.search && !parsed.hash) {
            result = result.slice(0, -1);
        }

        return result;
    } catch {
        return undefined;
    }
}
